import { Type } from '@angular/core';

/**
 * Checks if an event is bubbling up from a particular element type.
 * Example: if a click event happened on an anchor element (or a child of an anchor element)
 *
 * @param event
 * @param targetType
 * @returns
 */
export function hasTarget<T>(event: Event, targetType: Type<T>): boolean {
    if (!event.currentTarget || !event.target) {
        return false;
    }

    const currentTarget = event.currentTarget as HTMLElement;
    const target = event.target as HTMLElement;

    return hasTargetInternal(target, currentTarget, targetType);
}

function hasTargetInternal<T>(target: HTMLElement | null, currentTarget: HTMLElement, targetType: Type<T>): boolean {
    if (target instanceof targetType) {
        return true;
    }

    if (currentTarget === target || !target) {
        return false;
    }

    return hasTargetInternal(target.parentElement, currentTarget, targetType);
}
